import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { useLang } from "../i18n";

const HERO_IMG =
  "https://images.unsplash.com/photo-1736506159893-22cca29b8018?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600";

const lineReveal = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.4 + i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

const Line = ({ children, i, className = "" }) => (
  <span className="block overflow-hidden pb-[0.18em]">
    <motion.span
      variants={lineReveal}
      custom={i}
      initial="hidden"
      animate="visible"
      className={`block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.55, 0.9]);

  return (
    <section
      id="hero"
      ref={ref}
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0 will-change-transform">
        <img src={HERO_IMG} alt="Ahşap kaplama dokusu" fetchPriority="high" decoding="async" className="w-full h-full object-cover" />
      </motion.div>
      <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 bg-[#0D0C0B]" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0C0B] via-transparent to-[#0D0C0B]/40" />

      {/* Belirgin arama çubuğu kaldırıldı — arama menüdeki çubuktan yapılır */}

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-20 md:pb-28">
        <div className="flex flex-col md:flex-row md:items-end justify-center mt-8 gap-8">
          <motion.button
            data-testid="hero-discover-btn"
            onClick={() => document.getElementById("hakkimizda")?.scrollIntoView({ behavior: "smooth" })}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.8, duration: 1 }}
            className="flex items-center justify-center gap-4 text-[#8C8681] hover:text-[#F2EFEB] transition-colors group"
          >
            <ArrowDown size={32} strokeWidth={1.5} className="animate-bounce group-hover:text-[#7BA05B]" />
            <span
              className="font-artistic normal-case tracking-wide text-3xl md:text-4xl text-[#F2EFEB] group-hover:text-[#7BA05B] transition-colors"
              style={{ textShadow: "0 2px 18px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.9)" }}
            >
              {t("hero.discover")}
            </span>
          </motion.button>
        </div>
      </div>
    </section>
  );
};
